import { getArmyDefense, getArmyOffense } from './colHelpers';
import { ArmiesAway, Province } from '../../../@types/KingdomResponse';
import { RacePersona } from '../../../@types/RacesResponse';
import { ArmyLite } from '../../../@types/State';
import { letterize } from '../../../helpers/NumberFormatting';

export const getArmiesData = (
  dataSet: Province[] | undefined,
  races: RacePersona[] | undefined
) => {
  if (!dataSet) return null;
  const arr: ArmyLite[] = [];
  dataSet.forEach((province: Province) => {
    const racePersona: RacePersona | undefined = races?.find(
      (x) => x.race === province.race && x.personality === province.personality
    );
    province.som?.armiesAway?.forEach((a: ArmiesAway, i: number) => {
      if (!province.som) return;
      const item: ArmyLite = {
        id: `${province.id}_${i + 1}`,
        pid: province.id,
        name: province.name,
        generals: a.generals,
        solds: a.solds,
        oSpecs: a.oSpecs,
        elites: a.elites,
        horses: a.horses,
        land: a.land,
        secondsRemaining: a.secondsRemaining,
        ambush: a.ambush,
        ageSeconds: province.som.ageSeconds,
        rawOff: letterize(getArmyOffense(a, racePersona)),
        modOff: letterize(
          getArmyOffense(a, racePersona) * (province.som.ome / 100)
        ),
        rawDef: letterize(getArmyDefense(a, racePersona)),
        modDef: letterize(
          getArmyDefense(a, racePersona) * (province.som.dme / 100)
        ),
      };
      arr.push(item);
    });
  });
  return arr.sort((a, b) => a.secondsRemaining - b.secondsRemaining);
};
